import { render, staticRenderFns } from "./ShashaTerms.vue?vue&type=template&id=191115a3&scoped=true&"
import script from "./ShashaTerms.vue?vue&type=script&lang=ts&"
export * from "./ShashaTerms.vue?vue&type=script&lang=ts&"
import style0 from "./ShashaTerms.vue?vue&type=style&index=0&id=191115a3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "191115a3",
  null
  
)

export default component.exports